/**
 * @generated SignedSource<<5e22e917bff976084824b06709969e49>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row881BadPattern$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"Row345BadPattern">;
  readonly " $fragmentType": "Row881BadPattern";
};
export type Row881BadPattern$key = {
  readonly " $data"?: Row881BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row881BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRemoteLinkedIssuesEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "Row881BadPattern",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        },
        {
          "kind": "Variable",
          "name": "isRemoteLinkedIssuesEnabled",
          "variableName": "isRemoteLinkedIssuesEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Row345BadPattern"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "6efd8acbecfca502083f4f0a42dfaecc";

export default node;
